module.exports = __webpack_public_path__ + "static/american-buffalo-ed17615b8662d94d2e4142433e0fc4f4.jpg";